import api from './api';
import { Poll } from '../types';

export const POLLS_CHANGED_EVENT = 'intranet:pollsChanged';

export function emitPollsChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(POLLS_CHANGED_EVENT));
}

export interface CreatePollPayload {
  title: string;
  description?: string;
  choices: string[];
  accessScope?: 'COMPANY' | 'BRANCH' | 'DEPARTMENT';
  branch?: string;
  department?: string;
}

export interface UpdatePollPayload {
  title?: string;
  description?: string;
  choices?: string[];
  accessScope?: 'COMPANY' | 'BRANCH' | 'DEPARTMENT';
  branch?: string;
  department?: string;
}

export const pollsService = {
  async getAll(): Promise<Poll[]> {
    const { data } = await api.get<Poll[]>('/polls');
    return data;
  },

  async getById(id: string): Promise<Poll> {
    const { data } = await api.get<Poll>(`/polls/${id}`);
    return data;
  },

  async create(payload: CreatePollPayload): Promise<Poll> {
    const { data } = await api.post<Poll>('/polls', payload);
    emitPollsChanged();
    return data;
  },

  async vote(pollId: string, choiceIndex: number): Promise<Poll> {
    const { data } = await api.post<Poll>(`/polls/${pollId}/vote`, { choiceIndex });
    emitPollsChanged();
    return data;
  },

  async endPoll(pollId: string): Promise<Poll> {
    const { data } = await api.post<Poll>(`/polls/${pollId}/end`, {});
    emitPollsChanged();
    return data;
  },

  async update(pollId: string, payload: UpdatePollPayload): Promise<Poll> {
    const { data } = await api.patch<Poll>(`/polls/${pollId}`, payload);
    emitPollsChanged();
    return data;
  },

  async remove(pollId: string): Promise<void> {
    await api.delete(`/polls/${pollId}`);
    emitPollsChanged();
  },
};
